import React from 'react';
import PropTypes from 'prop-types';
import { cn } from '@express-labs/raven-tools';
import MyAccountLink from '../MyAccountLink';
import MyAccountAuxiliaryNav from '../MyAccountAuxiliaryNav';
import DynamicHeader from '../DynamicHeader';
import AccountPanel from '../AccountPanel';
import s from './LogInState.module.scss';
import routes from '../../../../../routes/routes';
import { LOYALTY_BRANDING_CONFIG } from '../../../../../../constants';

const { loggedOut } = LOYALTY_BRANDING_CONFIG.hoverableSlideOutModal;
const { creditCardIcon, creditCardTitle } = loggedOut;
const staticLink = [
  {
    icon: 'account', title: routes.myAccount.title, route: routes.myAccount.path, linkId: '01',
  },
  {
    icon: 'onlineOrder',
    title: routes.onlineOrder.title,
    route: routes.onlineOrder.path,
    linkId: '02',
  },
  {
    icon: 'rewards', title: routes.rewards.title, route: routes.rewards.path, linkId: '03',
  },
  {
    icon: creditCardIcon,
    title: creditCardTitle,
    route: routes.next.nextCard.path,
    linkId: '04',
  },
  {
    icon: 'payBill',
    title: routes.next.signIn.title,
    route: routes.next.signIn.path,
    linkId: '05',
  },
  {
    icon: 'signout',
    title: routes.signOut.title,
    route: routes.signOut.path,
    state: routes.signOut.state,
    linkId: '024',
  },
];

export default function LogInState(props) {
  const { className, flagNewTiers, removeScrollFreeze } = props;

  return (
    <div className={cn(s.container, className)} aria-label="logged in">
      {flagNewTiers ? <AccountPanel removeScrollFreeze={removeScrollFreeze} /> : <DynamicHeader />}
      {staticLink.map((val) => (
        <MyAccountLink
          icon={val.icon}
          key={val.linkId}
          title={val.title}
          ariaLabel={val.icon}
          state={val.state}
          route={val.route}
        />
      ))}
      <MyAccountAuxiliaryNav />
    </div>
  );
}

LogInState.propTypes = {
  className: PropTypes.string,
  data: PropTypes.shape({}),
  flagNewTiers: PropTypes.bool,
  removeScrollFreeze: PropTypes.func,
};

LogInState.defaultProps = {
  className: null,
  data: {},
  flagNewTiers: false,
  removeScrollFreeze: null,
};
